var React = require('react');

function SuccessInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50","cy":"50","r":"48","stroke":"#B53162","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M74.9142 37.4142C75.6953 36.6332 75.6953 35.3668 74.9142 34.5858C74.1332 33.8047 72.8668 33.8047 72.0858 34.5858L74.9142 37.4142ZM43.5 66L42.0858 67.4142C42.8668 68.1953 44.1332 68.1953 44.9142 67.4142L43.5 66ZM29.9142 49.5858C29.1332 48.8047 27.8668 48.8047 27.0858 49.5858C26.3047 50.3668 26.3047 51.6332 27.0858 52.4142L29.9142 49.5858ZM72.0858 34.5858L42.0858 64.5858L44.9142 67.4142L74.9142 37.4142L72.0858 34.5858ZM44.9142 64.5858L29.9142 49.5858L27.0858 52.4142L42.0858 67.4142L44.9142 64.5858Z","fill":"#B53162","key":1})]);
}

SuccessInline.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = SuccessInline;

SuccessInline.default = SuccessInline;
